import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App.vue'
import CKEditor from '@ckeditor/ckeditor5-vue2';

// Global Varaibles

//
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;
// The server closes a service whose subscription ended ({expired: code}, Nodejs src/access.js):
// open the renewal page instead of leaving the page half loaded.
$(document).ajaxSuccess(function(e, xhr){
  var r = xhr && xhr.responseJSON;
  if(r && r.expired && typeof r.expired == 'string' && window.location.pathname != '/expired'){
    window.location.replace('/expired?service=' + encodeURIComponent(r.expired));
  }
});
//
// «دخول بحساب المدرسة» from the admin (/autologin/<jwt>): switch the stored account BEFORE the app starts.
// It used to happen inside the page, after the menu and header had already called the server with the
// account stored before (another school / an old session) — so «JWT not valid» showed first.
var AUTOLOGIN = (function(){
  var m = window.location.pathname.match(/^\/autologin\/([^/?#]+)/);
  if(!m) return false;
  var tok = decodeURIComponent(m[1]);
  var old = window.location.href.split("?=")[1];   // old link form: /autologin/x?=<jwt>
  if(old) tok = decodeURIComponent(old);
  localStorage.setItem("user", JSON.stringify({jwt: tok, activated: true}));
  localStorage.setItem("isAdmin", "true");
  window.location.replace("/");
  return true;
})();

window.api = "https://server.tahdir.net"


if(window.location.href.includes("localhost:80") || window.location.href.includes("192.168")){
  window.api = "http://127.0.0.1:3000";
}
if(window.location.href.includes('_teachers')){
  if(localStorage.getItem('user')){
    localStorage.setItem("jwt", JSON.parse(localStorage.getItem("user")).jwt)
  }
}

//
localStorage.setItem("api", window.api)

window.hyear = localStorage.getItem('hyear') ?? `1447 / 1448 هـ`
window.hyear_single = localStorage.getItem('hyear_single') ??`1447 هـ`
window.semster = localStorage.getItem('semster') ?? "الاول"
window.start_date = localStorage.getItem('start_date') ?? "2026-08-23"

window.DEFAULT_MINISTRY_NAME = "وزارة التعليم"
window.DEFAULT_MINISTRY_LOGO = "https://cdn-static.brmja.com/storage/scrapped/62793ceb03c19132886968.jpg"

window.refreshMinistrySettings = function(){
  try {
    var u = JSON.parse(localStorage.getItem('user'));
    var name = u && u.settings && u.settings.ministry_name;
    var logo = u && u.settings && u.settings.ministry_logo;
    window.ministry_name = (name && name !== "null" && name !== "undefined") ? name : window.DEFAULT_MINISTRY_NAME;
    window.ministry_logo = (logo && logo !== "null" && logo !== "undefined") ? logo : window.DEFAULT_MINISTRY_LOGO;
  } catch(e) {
    window.ministry_name = window.DEFAULT_MINISTRY_NAME;
    window.ministry_logo = window.DEFAULT_MINISTRY_LOGO;
  }
}
window.refreshMinistrySettings();

setInterval(() => {
  window.hyear = localStorage.getItem('hyear') ?? `1447 / 1448 هـ`
  window.hyear_single = localStorage.getItem('hyear_single') ??`1447 هـ`
  window.semster = localStorage.getItem('semster') ?? "الاول"
  window.start_date = localStorage.getItem('start_date') ?? "2026-08-23"
  window.refreshMinistrySettings()
}, 5000);

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use( CKEditor );

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

window.alert = function(text, status='bg-secondary'){
  $("#open-alert").click()
  setTimeout(function(){
    $("#alert-msg").html(`<div class='alert text-white g text-center ${status == 100 ? 'bg-success' : (status == 200 ? 'bg-danger' : 'bg-secondary')}'>${text}</div>`)
    if(text?.includes("تم الارسال بنجاح٫ يمكنك تصفح ارشيف الرسائل")){
      $("#alert-msg .alert").append(`<br><br>
      <a href='/archive' class='btn btn-primary'><i class='fa fa-archive'></i> عرض الارشيف</a>
      `)
    }
    // a «meta» send refused because Meta is not ready (code 'meta_not_ready'): the way to activate it
    if(typeof text == 'string' && text.includes("فعّل واتساب ميتا أولاً")){
      $("#alert-msg .alert").append(`<br><br>
      <a href='/_whatsapp/meta' class='btn btn-light'><i class='fa fa-whatsapp'></i> فتح صفحة واتساب ميتا</a>
      `)
    }
  }, 100)
}

if(!localStorage.getItem('first')){
  localStorage.setItem('first', 'true');
  localStorage.setItem("favs", `[{"title":"الحضور والغياب اليومي","url":"/_students/reports/daily"},{"title":"استعراض الطلاب","url":"/_students/list"},{"title":"شاشة الاستئذان","url":"/_students/scan/end"}]`)
}

window.checkPer = function(per){
  var s = false;
  if(localStorage.getItem('user')){
    var user = JSON.parse(localStorage.getItem('user'));
    if(user.subuser){
      if(user.pers.includes("*") || user.pers.includes(per)){
        s = true;
      }
    }else{
      s = true;
    }
  }
  return s;
};

window.convertToHijri = function(x){return x;}

// Chart colours for the new look (CanvasJS). Pages call it before creating charts.
window.tahdirChartTheme = function(CanvasJS){
  if(window.__tahdirChartColors || !CanvasJS || !CanvasJS.addColorSet) return;
  window.__tahdirChartColors = true;
  CanvasJS.addColorSet("tahdir", ["#1D4ED8", "#12B76A", "#F79009", "#F04438", "#0BA5EC", "#7A5AF8", "#98A2B3", "#0E9384", "#EE46BC", "#FDB022"]);
}
Vue.prototype.checkPer = window.checkPer;

// "إشعار الجوال" buttons reuse each page's send (method=push). The pages then say the messages
// are in the archive, which is not where pushes go: show what really happened instead.
$(document).ajaxSuccess(function(e, xhr, settings){
  if(!/\/user\/messages\/send-arr$/.test(settings.url || '') || !/(^|&)method=push(&|$)/.test(settings.data || '')) return;
  var r = xhr.responseJSON;
  if(!r || r.status != 100 || !r.response) return;
  var x = r.response;
  // Names of the students (or teachers) whose parents have no device registered for push yet.
  var names = (x.no_app_names || []);
  var who = names.slice(0, 5).join('، ') + (names.length > 5 ? ' و' + (names.length - 5) + ' آخرين' : '');
  var how = 'يُسجَّل الجهاز تلقائياً عندما يفتح ولي الأمر آخر إصدار من التطبيق ويسمح بالإشعارات.';
  setTimeout(function(){
    alert(x.reached
      ? 'تم إرسال إشعار الجوال إلى ' + x.reached + ' من ' + x.recipients + '.' + (x.no_app ? ' لم يصل إلى ' + (who || x.no_app) + ' لعدم وجود جهاز مسجّل. ' + how : '')
      : 'لم يُرسل أي إشعار: لا يوجد جهاز مسجّل للإشعارات' + (who ? ' لـ ' + who : ' للمختارين') + '. ' + how + ' يمكنك الإرسال الآن بالواتساب أو الرسائل النصية.', x.reached ? 100 : 200);
  }, 350);
});

// Phones/tablets: table columns get squeezed until dates break at every "-" ("15-" / "04-" / "1448").
// Short cells (dates, times, names, numbers) are tagged `sk-short` so skin.scss keeps them on one line
// (the table scrolls sideways); long text (reasons, notes) keeps wrapping. Only adds a class.
(function(){
  var small = window.matchMedia('(max-width: 991.98px)'), queued = false;
  function tag(){
    queued = false;
    if(!small.matches) return;
    document.querySelectorAll('.table td, .table th').forEach(function(cell){
      var n = cell.textContent.replace(/\s+/g, ' ').trim().length;
      var s = n > 0 && n <= 32;
      if(cell.classList.contains('sk-short') != s) cell.classList.toggle('sk-short', s);
    });
  }
  function later(){
    if(!queued){ queued = true; setTimeout(tag, 150); }
  }
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if(small.addEventListener) small.addEventListener('change', later);
})();

Vue.mixin({
  computed: {
    ministry_name(){ return window.ministry_name || window.DEFAULT_MINISTRY_NAME; },
    ministry_logo(){ return window.ministry_logo || window.DEFAULT_MINISTRY_LOGO; }
  }
})
import { BDropdown, BDropdownItem } from 'bootstrap-vue';

// تسجيل المكونات عالمياً
Vue.component('b-dropdown', BDropdown);
Vue.component('b-dropdown-item', BDropdownItem);

// «واتساب ميتا» as a send channel on every page (src/libs/meta-channel.js): the button / option is shown
// everywhere, with a lock until Meta is ready (POST /user/whatsapp/meta/ready); the page's send('meta') does the rest.
import MetaSendItem from '@/views/components/meta/MetaSendItem.vue';
import MetaSendButton from '@/views/components/meta/MetaSendButton.vue';
import MetaMethodOption from '@/views/components/meta/MetaMethodOption.vue';
import MetaMethodHint from '@/views/components/meta/MetaMethodHint.vue';
import { metaForget, metaWatch } from '@/libs/meta-channel';
Vue.component('meta-send-item', MetaSendItem);
Vue.component('meta-send-button', MetaSendButton);
Vue.component('meta-method-option', MetaMethodOption);
Vue.component('meta-method-hint', MetaMethodHint);
metaWatch(router);
// the server refused a «meta» send (not ready any more): read the state again, so the option shows its lock
$(document).ajaxSuccess(function(e, xhr){
  var r = xhr && xhr.responseJSON;
  if(r && r.code == 'meta_not_ready') metaForget();
});
// nothing to start while the page is being replaced (autologin above)
if(!AUTOLOGIN) new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')